module.exports = __webpack_public_path__ + "img/1979.37089918.jpg";